let CALLBACK_URL_DO
if (process.env.REACT_APP_NODE_ENV === 'local') {
    CALLBACK_URL_DO = 'http://localhost:3000/api/'
} else if (process.env.REACT_APP_NODE_ENV === 'development') {
    CALLBACK_URL_DO = 'https://dev.pearsonct.design/server/api/'
} else {
    CALLBACK_URL_DO = 'https://pearsonct.design/server/api/'
}
export default CALLBACK_URL_DO
